import { API } from "@/lib/api";

export const mediaUrl = (id) => (id ? `${API}/public/media/${id}` : "");

export const pathForSlug = (slug) => (slug === "accueil" ? "/" : `/${slug}`);

export const SECTIONS = [
  { id: "club", label: "Le club", to: "/le-club" },
  { id: "plateforme", label: "Plateforme", to: "/plateforme" },
  { id: "operations", label: "Opérations", to: "/operations/projets-collectifs" },
  { id: "ressources", label: "Ressources", to: "/ressources/blog" },
];

export const menuPages = (pages, section) => pages.filter((p) => p.section === section && p.in_menu).sort((a, b) => a.order - b.order);
